var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('v-server-table',{ref:"datatable",attrs:{"url":_vm.api,"name":_vm.tableName,"columns":_vm.columns,"options":_vm.options}}),_vm._v(" "),_c('end-shift-report',{ref:"endShiftReport"}),_vm._v(" "),_c('end-shift-report-v2',{ref:"endShiftReportV2"})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22cc92f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/franchise_component/report/drawersession/vuetable-drawer-session.vue
// module id = zR2D
// module chunks = 50